document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('select#field_key').forEach(function(el) {
    el.addEventListener('change', function(e) {
      if (el.value === 'Custom Label') {
        var wrapper = el.parentNode;
        var field = wrapper.parentNode;

        field.querySelector('label').classList.remove('inline');
        field.removeChild(wrapper);
        field.insertAdjacentHTML('beforeend', '<input type="text" name="field[key]" id="field_key">');
      }
    });
  });

});
